import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import { JourneyEvent } from "@/entities/annotation";
import {
  JourneyProximity,
  JourneyTransaction,
  ProximityTimeRange,
  TrackPersistence,
} from "@/shared/api/lod-api";
import { getHandSide } from "./helpers";

interface FormattedEventData {
  title: string;
  timestamp: Date;
  cameraId: string;
}

export const formatEventData = (
  event:
    | JourneyEvent
    | JourneyTransaction
    | TrackPersistence
    | JourneyProximity
    | ProximityTimeRange
): FormattedEventData => {
  if (event.type === ANNOTATION_TYPES.TRANSACTION) {
    return {
      title: `${event.action} x ${event.count} ${event.uom} - ${event.name}`,
      timestamp: new Date(event.timestamp),
      cameraId: String(event.cameraId),
    };
  }

  if (event.type === ANNOTATION_TYPES.TRACK_PERSISTENCE) {
    return {
      title: "track persistence",
      timestamp: new Date(event.timestamp),
      cameraId: String(event.cameraId),
    };
  }

  if (event.type === ANNOTATION_TYPES.PROXIMITY) {
    return {
      title: `proximity - ${getHandSide(event.handId)?.toLowerCase()} hand`,
      timestamp: new Date(event.timestamp),
      cameraId: String(event.cameraId),
    };
  }

  if (event.type === ANNOTATION_TYPES.PROXIMITY_TIME_RANGES) {
    return {
      title: `proximity time ranges - ${getHandSide(event.handId)?.toLowerCase()} hand`,
      timestamp: new Date(event.timestamp),
      cameraId: String(event.cameraId),
    };
  }

  return {
    title: event.eventType,
    timestamp: new Date(event.timestamp),
    cameraId: event.cameraId,
  };
};
